import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterLabel = ({ number, title }) => (
  <Reveal className="mb-14 flex items-end justify-between border-b border-white/10 pb-6">
    <div className="flex items-center gap-4">
      <span className="font-mono-accent text-sm tracking-[0.2em] text-[#FF2A2A]">
        {number}
      </span>
      <h2 className="font-display text-3xl font-bold uppercase leading-none tracking-tight text-[#FAFAFA] sm:text-4xl md:text-5xl">
        {title}
      </h2>
    </div>
    <span className="hidden font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#52525B] md:block">
      Autofficina Ciro Natale
    </span>
  </Reveal>
);
